export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/9bcd33e9897c7ece906f4b3140e3adee.png"
          alt="DX Consulting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-12 text-center">
        {/* メインキャッチコピー */}
        <h1 className="text-3xl lg:text-5xl font-bold text-white mb-6 leading-tight tracking-tight">
          <span className="block">DX、何から始めればいいかわからない。</span>
          <span className="block mt-2 bg-gradient-to-r from-white via-white to-white/80 bg-clip-text">最初の一歩から、弊社が伴走します。</span>
        </h1>
        
        <p className="text-xl lg:text-2xl text-white/90 mb-6 font-medium leading-relaxed max-w-3xl mx-auto">
          戦略設計・実装・定着まで。<br className="hidden sm:block" />
          DXを段階的に進める伴走型支援サービスです。
        </p>
        
        {/* 特徴バッジ */}
        <div className="flex flex-wrap items-center justify-center gap-3 lg:gap-4 mb-10">
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
            <div className="w-5 h-5 flex items-center justify-center bg-[#037555] rounded-full">
              <i className="ri-check-line text-xs text-white"></i>
            </div>
            <span className="text-sm lg:text-base text-white font-medium">初期費用0円</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
            <div className="w-5 h-5 flex items-center justify-center bg-[#037555] rounded-full">
              <i className="ri-check-line text-xs text-white"></i>
            </div>
            <span className="text-sm lg:text-base text-white font-medium">月額制プラン</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
            <div className="w-5 h-5 flex items-center justify-center bg-[#037555] rounded-full">
              <i className="ri-check-line text-xs text-white"></i>
            </div>
            <span className="text-sm lg:text-base text-white font-medium">スモールスタート</span>
          </div>
        </div>

        {/* CTAボタン */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="group inline-flex items-center justify-center px-8 py-4 bg-white text-[#12335f] text-base font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-search-eye-line text-lg"></i>
            </div>
            無料DX推進診断をする
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="#contact"
            className="group inline-flex items-center justify-center px-8 py-4 bg-[#9a1e23] text-white text-base font-bold rounded-lg hover:bg-[#7d181c] transition-all duration-300 cursor-pointer whitespace-nowrap border-2 border-white/30 hover:border-white/50 hover:-translate-y-0.5"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-mail-send-line text-lg"></i>
            </div>
            無料相談する
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
      
      {/* スクロールインジケーター */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 flex items-center justify-center border-2 border-white/40 rounded-full">
          <i className="ri-arrow-down-line text-white/60 text-lg"></i>
        </div>
      </div>
    </section>
  );
}
